import { useState } from 'react';

import { useGenericClick } from 'services/datalayer/browse';

export const useOpenEmailFlow = () => {
  const handleGenericClick = useGenericClick();
  const [isEmailFlow, setIsEmailFlow] = useState(false);

  const handleOpenEmailFlow = () => {
    handleGenericClick({ clickItem: 'Authenticate email' });
    setIsEmailFlow(true);
  };

  const handleCloseEmailFlow = () => {
    setIsEmailFlow(false);
  };

  return {
    isEmailFlow,
    handleOpenEmailFlow,
    handleCloseEmailFlow,
  };
};
